import React, { ChangeEvent } from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import intl from 'react-intl-universal';
import './SearchRow.css';
import { fixIosFocusProblem } from '../../utils/dom';

interface ISearchRow {
  search?: (input: string) => void;
  clear?: () => void;
  placeholder?: string;
}
@observer
class SearchRow extends React.Component<ISearchRow> {
  @observable input = '';
  @action changeInput = (e: ChangeEvent<HTMLInputElement>) => {
    this.input = e.target.value;
  };
  @computed get active() {
    return !!this.input;
  }
  search = () => {
    const { input } = this;
    if (!input) {
      console.warn('没有输入');
      this.props.clear && this.props.clear();
      return;
    }
    this.props.search && this.props.search(input);
  };
  render() {
    return (
      <div className="search-row">
        <i className={this.active ? 'search-icon active' : 'search-icon'} />
        <input
          placeholder={
            this.props.placeholder ||
            intl.get('Enter your participate no., letters included')
          }
          value={this.input}
          onChange={this.changeInput}
          // onBlur={e => fixIosFocusProblem(e.target)}
        />
        <button
          className={'search-btn ' + (this.active ? 'active' : '')}
          onClick={this.search}
        >
          {intl.get('Search')}
        </button>
      </div>
    );
  }
}

export default SearchRow;
